var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Tick from "./shared/tick.vue";
import SelectionChoice from "./plans/selection-choice.vue";
import IncrementingNumber from "./shared/incrementing-number.vue";
import WifiSignalIcon from "./shared/wifi-signal-icon.vue";
import Loader from "./shared/loader.vue";
import PlanCard from "./plans/plan-card.vue";
import { filter, first, isEqual } from "lodash-es";
import { plansDetailService } from "../services/plans-detail.service";
var PlanSelector = /** @class */ (function (_super) {
    __extends(PlanSelector, _super);
    function PlanSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'plan-selector';
        _this.plansDetailService = plansDetailService;
        _this.loaded = false;
        _this.loadingPlans = false;
        _this.loadingSpeedTiers = false;
        _this.contractLengths = [];
        _this.activeContractLength = null;
        _this.speedTiers = [];
        _this.activeSpeedTier = null;
        _this.technologyDetail = null;
        _this.planTypes = [];
        _this.activePlanType = null;
        _this.plans = [];
        _this.filteredPlans = [];
        _this.activePlan = null;
        return _this;
    }
    PlanSelector.prototype.created = function () {
        this.contractLengths = this.plansDetailService.getContractLengths(this.technology);
        this.loaded = false;
        this.loadingPlans = true;
        this.loadingSpeedTiers = true;
    };
    Object.defineProperty(PlanSelector.prototype, "filteredContractLengths", {
        get: function () {
            var _this = this;
            return filter(this.contractLengths, function (contractLength) {
                return _this.forceContractLength ? contractLength.name === _this.forceContractLength : true;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSelector.prototype, "visibleContractLengths", {
        get: function () {
            return this.filteredContractLengths;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSelector.prototype, "filteredPlanTypes", {
        get: function () {
            var _this = this;
            return filter(this.planTypes, function (planType) {
                return _this.forcePlanType ? planType.code === _this.forcePlanType : true;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSelector.prototype, "visiblePlanTypes", {
        get: function () {
            return filter(this.filteredPlanTypes, function (planType) { return !planType.is_hidden; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSelector.prototype, "visibleSpeedTiers", {
        get: function () {
            return filter(this.speedTiers, function (speedTier) { return !speedTier.is_hidden; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanSelector.prototype, "visiblePlans", {
        get: function () {
            return filter(this.plans, function (plan) { return !plan.is_hidden; });
        },
        enumerable: false,
        configurable: true
    });
    PlanSelector.prototype.onActiveContractLengthChange = function (contractLength) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, plansDetailService.getPlanTypes(this.technology)];
                    case 1:
                        _a.planTypes = _c.sent();
                        if (!(this.loaded || this.planTypes.length === 0)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, plansDetailService.getSpeedTiers(this.technology, this.addressId, contractLength.name, this.forcePlanType ? this.forcePlanType :
                                (this.activePlanType ? this.activePlanType.code : undefined))];
                    case 2:
                        _b.speedTiers = _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PlanSelector.prototype.onContractLengthsChange = function (contractLengths, oldContractLengths) {
        if (isEqual(contractLengths, oldContractLengths)) {
            return;
        }
        this.activeContractLength = (first(this.filteredContractLengths.filter(function (contractLength) { return contractLength.is_popular; })) ||
            first(this.filteredContractLengths) ||
            null);
    };
    PlanSelector.prototype.onActivePlanTypeChange = function (planType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!planType) {
                            return [2 /*return*/];
                        }
                        this.contractLengths.map(function (contractLength) {
                            var _a, _b;
                            var hide_for_plan_type = (contractLength.hasOwnProperty('hide_for_plan_type') ?
                                contractLength.hide_for_plan_type :
                                null);
                            contractLength.is_disabled = ((_a = _this.activePlanType) === null || _a === void 0 ? void 0 : _a.code) === hide_for_plan_type;
                            contractLength.is_hidden = ((_b = _this.activePlanType) === null || _b === void 0 ? void 0 : _b.code) === hide_for_plan_type;
                        });
                        // If a disabled contract length is selected
                        if (this.activeContractLength && this.activeContractLength.is_disabled) {
                            this.activeContractLength = (first(this.filteredContractLengths.filter(function (contractLength) { return contractLength.is_popular && !contractLength.is_disabled; })) ||
                                first(this.filteredContractLengths.filter(function (contractLength) { return !contractLength.is_disabled; })) ||
                                null);
                        }
                        this.$forceUpdate();
                        _a = this;
                        return [4 /*yield*/, plansDetailService.getSpeedTiers(this.technology, this.addressId < 0 ? undefined : this.addressId, this.activeContractLength ? this.activeContractLength.name : undefined, this.forcePlanType ? this.forcePlanType :
                                (this.activePlanType ? this.activePlanType.code : undefined))];
                    case 1:
                        _a.speedTiers = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanSelector.prototype.onPlanTypesChange = function (planTypes, oldPlanTypes) {
        if (isEqual(planTypes, oldPlanTypes)) {
            return;
        }
        this.activePlanType = (first(this.filteredPlanTypes.filter(function (planType) { return planType.is_popular; })) ||
            first(this.filteredPlanTypes) ||
            null);
    };
    PlanSelector.prototype.onActiveSpeedTierChange = function (speedTier) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!speedTier) {
                            return [2 /*return*/];
                        }
                        this.loadingPlans = true;
                        _a = this;
                        return [4 /*yield*/, plansDetailService.plansForSpeedTier(this.technology, speedTier.speed_tier)];
                    case 1:
                        _a.plans = (_b.sent());
                        this.loadingPlans = false;
                        this.loaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanSelector.prototype.onSpeedTiersChange = function (speedTiers, oldSpeedTiers) {
        if (isEqual(speedTiers, oldSpeedTiers)) {
            return;
        }
        this.activeSpeedTier = (first(filter(this.speedTiers, function (speedTier) { return speedTier.is_popular; })) ||
            first(this.speedTiers));
    };
    PlanSelector.prototype.hasSlot = function (name) {
        return !!this.$slots[name];
    };
    __decorate([
        Prop({ default: '', type: String })
    ], PlanSelector.prototype, "technology", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanSelector.prototype, "pageTechnology", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanSelector.prototype, "confirmedTechnology", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanSelector.prototype, "speedTier", void 0);
    __decorate([
        Prop({ default: '', type: Number })
    ], PlanSelector.prototype, "addressId", void 0);
    __decorate([
        Prop({ type: String })
    ], PlanSelector.prototype, "forcePlanType", void 0);
    __decorate([
        Prop({ type: String })
    ], PlanSelector.prototype, "forceContractLength", void 0);
    __decorate([
        Watch('activeContractLength')
    ], PlanSelector.prototype, "onActiveContractLengthChange", null);
    __decorate([
        Watch('contractLengths')
    ], PlanSelector.prototype, "onContractLengthsChange", null);
    __decorate([
        Watch('activePlanType')
    ], PlanSelector.prototype, "onActivePlanTypeChange", null);
    __decorate([
        Watch('planTypes')
    ], PlanSelector.prototype, "onPlanTypesChange", null);
    __decorate([
        Watch('activeSpeedTier')
    ], PlanSelector.prototype, "onActiveSpeedTierChange", null);
    __decorate([
        Watch('speedTiers')
    ], PlanSelector.prototype, "onSpeedTiersChange", null);
    PlanSelector = __decorate([
        Component({
            components: {
                Tick: Tick,
                IncrementingNumber: IncrementingNumber,
                PlanCard: PlanCard,
                WifiSignalIcon: WifiSignalIcon,
                SelectionChoice: SelectionChoice,
                Loader: Loader
            }
        })
    ], PlanSelector);
    return PlanSelector;
}(Vue));
export default PlanSelector;
